import ScheduleServices from 'www/modules/Schedule/classes/ScheduleServices'
import { NAMESPACE } from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/constants'

function createTimetable() {
  new ScheduleServices({
    selectorContainersSlots: `.${NAMESPACE.slotContainer}`,
    selectorContainerObserver: `[${NAMESPACE.observerContainerSlots}]`,
  })
}

export default createTimetable
